import React from 'react';
import { Clock } from 'lucide-react';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 bg-navy-950 border-b border-gold-500/30 text-white shadow-md" data-id="element-211">
      <div className="max-w-6xl mx-auto px-4 py-3" data-id="element-212">
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-center" data-id="element-213">
          {/* Spots */}
          <div className="flex items-center gap-2.5" data-id="element-214">
            <span className="relative flex h-2 w-2" data-id="element-215">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-gold-400 opacity-75" data-id="element-216"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-gold-400" data-id="element-217"></span>
            </span>
            <p className="text-[13px] md:text-sm tracking-wide" data-id="element-218">
              <span className="text-gold-400 uppercase font-bold tracking-widest text-[11px] md:text-xs" data-id="element-219">
                Atención
              </span>
              <span className="text-white/40 mx-2" data-id="element-220">·</span>
              <span className="text-navy-100" data-id="element-221">Tu tiempo es</span>{' '}
              <span className="text-gold-300 font-bold font-serif italic" data-id="element-222">
                Ahora
              </span>
            </p>
          </div>

          <span className="hidden md:inline-block w-px h-4 bg-white/15" data-id="element-223"></span>

          {/* Price */}
          

          <span className="hidden md:inline-block w-px h-4 bg-white/15" data-id="element-224"></span>

          {/* Deadline */}
          <div className="flex items-center gap-1.5 text-[13px] md:text-sm text-navy-100" data-id="element-225">
            <Clock className="w-3.5 h-3.5 text-gold-400" data-id="element-226" />
            
          </div>
        </div>
      </div>
    </div>;
}